import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

import { LOGIN_REFERRER } from 'src/common/constants';
import { useGoogleOneTapAuthMutation } from 'src/common/slices/auth';
import { apiSlice } from 'src/features/api/api-slice';
import { useProcessPreSignupState } from 'src/features/pre-signup-onboarding/hooks/use-process-pre-signup-state';

export const useGoogleOneTapAuth = () => {
  const navigate = useNavigate();
  const [googleOneTapAuth] = useGoogleOneTapAuthMutation();
  const { handlePreSignupFlow } = useProcessPreSignupState();

  const handleAuth = async (credential: string, nonce: string) => {
    const result = await googleOneTapAuth({ credential, nonce }).unwrap();
    if (result?.success) {
      Cookies.set('logged-in-hint', 'true', { path: '/' });

      window.sessionStorage.removeItem(LOGIN_REFERRER);

      apiSlice.util.resetApiState();

      const preSignupOnboardingCompleted = await handlePreSignupFlow();
      if (preSignupOnboardingCompleted) return;

      if (result.user.isNew) {
        navigate('/onboarding');
        return;
      }

      const referrer = window.location.pathname;
      if (referrer && referrer !== '/login') {
        // we trigger a full page reload to clear the google one tap prompt
        window.location.href = referrer;
        return;
      }
      navigate('/dashboard');
    }
  };

  return handleAuth;
};
